<template>
  <div v-if="dateType === 1" style="margin-top: 10px">
    <el-radio-group @change="sendValue" v-model="dayOne" style="width: 320px;">
      <el-radio :label="1">
        每天
      </el-radio>
      <el-radio :label="2">
        每个工作日(周一到周五)
      </el-radio>
    </el-radio-group>
  </div>
  <div v-else-if="dateType === 2" style="margin-top: 10px">
    <div class="week-select">
      <span :key="item.time" class="date-week" v-for="(item, index) in weekDate" v-bind:class="{ active: item.selected }" @click="changeAction(index)">{{ item.time }}</span>
    </div>
  </div>
  <div v-else-if="dateType === 3" style="margin-top: 10px">
    <div class="week-select">
      <span :key="item.time" class="date-week" v-for="(item, index) in dayDate" v-bind:class="{ active: item.selected }" @click="changeDateAction(index)">{{ item.time }}</span>
    </div>
  </div>
  <div v-else-if="dateType === 4" style="margin-top: 10px">
    <div class="week-select">
      <span :key="item.time" class="date-week" v-bind:class="{ active: item.selected }" v-for="(item, index) in monthDate" @click="changeMonth(index)">{{ item.time }}</span>
    </div>
    <div class="week-select">
      <span :key="item.time" class="date-week" v-bind:class="{ active: item.selected }" v-for="(item, index) in dayDateYear" @click="changeYearDateAction(index)">{{ item.time }}</span>
    </div>
  </div>
</template>

<script>
// import { regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
// import { getCustomerAttributeList, getGroupList } from '@/api/customer.js'
// import { mapGetters } from 'vuex'
export default {
  name: 'DateTemplate',
  props: ['dateType', 'timeShow'],
  data () {
    return {
      timeOptions: '',
      active: true,
      dayOne: this.timeShow.dayOne,
      value2: '',
      weekDate: [
        {
          selected: true,
          time: '周一'
        },
        {
          selected: false,
          time: '周二'
        },
        {
          selected: false,
          time: '周三'
        },
        {
          selected: false,
          time: '周四'
        },
        {
          selected: false,
          time: '周五'
        },
        {
          selected: false,
          time: '周六'
        },
        {
          selected: false,
          time: '周日'
        }
      ],
      dayDate: [
        {
          selected: true,
          time: '1日',
          value: 1
        },
        {
          selected: false,
          time: '2日',
          value: 2
        },
        {
          selected: false,
          time: '3日',
          value: 3
        },
        {
          selected: false,
          time: '4日',
          value: 4
        },
        {
          selected: false,
          time: '5日',
          value: 5
        },
        {
          selected: false,
          time: '6日',
          value: 6
        },
        {
          selected: false,
          time: '7日',
          value: 7
        },
        {
          selected: false,
          time: '8日',
          value: 8
        },
        {
          selected: false,
          time: '9日',
          value: 9
        },
        {
          selected: false,
          time: '10日',
          value: 10
        },
        {
          selected: false,
          time: '11日',
          value: 11
        },
        {
          selected: false,
          time: '12日',
          value: 12
        },
        {
          selected: false,
          time: '13日',
          value: 13
        },
        {
          selected: false,
          time: '14日',
          value: 14
        },
        {
          selected: false,
          time: '15日',
          value: 15
        },
        {
          selected: false,
          time: '16日',
          value: 16
        },
        {
          selected: false,
          time: '17日',
          value: 17
        },
        {
          selected: false,
          time: '18日',
          value: 18
        },
        {
          selected: false,
          time: '19日',
          value: 19
        },
        {
          selected: false,
          time: '20日',
          value: 20
        },
        {
          selected: false,
          time: '21日',
          value: 21
        },
        {
          selected: false,
          time: '22日',
          value: 22
        },
        {
          selected: false,
          time: '23日',
          value: 23
        },
        {
          selected: false,
          time: '24日',
          value: 24
        },
        {
          selected: false,
          time: '25日',
          value: 25
        },
        {
          selected: false,
          time: '26日',
          value: 26
        },
        {
          selected: false,
          time: '27日',
          value: 27
        },
        {
          selected: false,
          time: '28日',
          value: 28
        },
        {
          selected: false,
          time: '29日',
          value: 29
        },
        {
          selected: false,
          time: '30日',
          value: 30
        },
        {
          selected: false,
          time: '31日',
          value: 31
        }
      ],
      monthDate: [
        {
          selected: true,
          time: '1月'
        },
        {
          selected: false,
          time: '2月'
        },
        {
          selected: false,
          time: '3月'
        },
        {
          selected: false,
          time: '4月'
        },
        {
          selected: false,
          time: '5月'
        },
        {
          selected: false,
          time: '6月'
        },
        {
          selected: false,
          time: '7月'
        },
        {
          selected: false,
          time: '8月'
        },
        {
          selected: false,
          time: '9月'
        },
        {
          selected: false,
          time: '10月'
        },
        {
          selected: false,
          time: '11月'
        },
        {
          selected: false,
          time: '12月'
        }
      ],
      dayDateYear: [
        {
          selected: true,
          time: '1日',
          value: 1
        },
        {
          selected: false,
          time: '2日',
          value: 2
        },
        {
          selected: false,
          time: '3日',
          value: 3
        },
        {
          selected: false,
          time: '4日',
          value: 4
        },
        {
          selected: false,
          time: '5日',
          value: 5
        },
        {
          selected: false,
          time: '6日',
          value: 6
        },
        {
          selected: false,
          time: '7日',
          value: 7
        },
        {
          selected: false,
          time: '8日',
          value: 8
        },
        {
          selected: false,
          time: '9日',
          value: 9
        },
        {
          selected: false,
          time: '10日',
          value: 10
        },
        {
          selected: false,
          time: '11日',
          value: 11
        },
        {
          selected: false,
          time: '12日',
          value: 12
        },
        {
          selected: false,
          time: '13日',
          value: 13
        },
        {
          selected: false,
          time: '14日',
          value: 14
        },
        {
          selected: false,
          time: '15日',
          value: 15
        },
        {
          selected: false,
          time: '16日',
          value: 16
        },
        {
          selected: false,
          time: '17日',
          value: 17
        },
        {
          selected: false,
          time: '18日',
          value: 18
        },
        {
          selected: false,
          time: '19日',
          value: 19
        },
        {
          selected: false,
          time: '20日',
          value: 20
        },
        {
          selected: false,
          time: '21日',
          value: 21
        },
        {
          selected: false,
          time: '22日',
          value: 22
        },
        {
          selected: false,
          time: '23日',
          value: 23
        },
        {
          selected: false,
          time: '24日',
          value: 24
        },
        {
          selected: false,
          time: '25日',
          value: 25
        },
        {
          selected: false,
          time: '26日',
          value: 26
        },
        {
          selected: false,
          time: '27日',
          value: 27
        },
        {
          selected: false,
          time: '28日',
          value: 28
        },
        {
          selected: false,
          time: '29日',
          value: 29
        },
        {
          selected: false,
          time: '30日',
          value: 30
        },
        {
          selected: false,
          time: '31日',
          value: 31
        }
      ],
      weekNum: this.timeShow.weekNum,
      dayNum: this.timeShow.dayNum,
      monthNum: this.timeShow.monthNum,
      yearDayNum: this.timeShow.yearDayNum
    }
  },
  watch: {
    dateType: function (val) {
      this.dateType = val
      console.log('val1', val)
      if (this.dateType === 1) {
        // 重置周
        for (let i in this.weekDate) {
          this.weekDate[i].selected = false
        }
        this.weekDate[0].selected = true
        // 重置日期
        for (let i in this.dayDate) {
          this.dayDate[i].selected = false
        }
        this.dayDate[0].selected = true
        // 重置月
        for (let i in this.monthDate) {
          this.monthDate[i].selected = false
        }
        this.monthDate[0].selected = true
        // 重置按年的日期
        for (let i in this.dayDateYear) {
          this.dayDateYear[i].selected = false
        }
        this.dayDateYear[0].selected = true
        this.weekNum = ''
        this.dayNum = ''
        this.monthNum = ''
        this.yearDayNum = ''
      } else if (this.dateType === 2) {
        // 重置日期
        for (let i in this.dayDate) {
          this.dayDate[i].selected = false
        }
        this.dayDate[0].selected = true
        // 重置月
        for (let i in this.monthDate) {
          this.monthDate[i].selected = false
        }
        this.monthDate[0].selected = true
        // 重置按年的日期
        for (let i in this.dayDateYear) {
          this.dayDateYear[i].selected = false
        }
        this.dayDateYear[0].selected = true
        this.dayNum = ''
        this.monthNum = ''
        this.yearDayNum = ''
        this.dayOne = 1
      } else if (this.dateType === 3) {
        // 重置周
        for (let i in this.weekDate) {
          this.weekDate[i].selected = false
        }
        this.weekDate[0].selected = true
        // 重置月
        for (let i in this.monthDate) {
          this.monthDate[i].selected = false
        }
        this.monthDate[0].selected = true
        // 重置按年的日期
        for (let i in this.dayDateYear) {
          this.dayDateYear[i].selected = false
        }
        this.dayDateYear[0].selected = true
        this.weekNum = ''
        this.monthNum = ''
        this.yearDayNum = ''
        this.dayOne = 1
      } else if (this.dateType === 4) {
        // 重置周
        for (let i in this.weekDate) {
          this.weekDate[i].selected = false
        }
        this.weekDate[0].selected = true
        // 重置日期
        for (let i in this.dayDate) {
          this.dayDate[i].selected = false
        }
        this.dayDate[0].selected = true
        this.weekNum = ''
        this.dayNum = ''
        this.dayOne = 1
      }
    },
    timeShow: function (val) {
      console.log('val', val)
      this.weekNum = val.weekNum
      this.dayNum = val.dayNum
      this.monthNum = val.monthNum
      this.yearDayNum = val.yearDayNum
      this.dayOne = val.dayOne
    }
  },
  computed: {
    // ...mapGetters([
    //   'getQuery'
    // ])
  },
  methods: {
    // 向父组件传值
    sendValue() {
      // 传值到父组件
      let choose = {}
      choose.weekNum = this.weekNum
      choose.dayNum = this.dayNum
      choose.monthNum = this.monthNum
      choose.yearDayNum = this.yearDayNum
      choose.dayOne = this.dayOne
      this.$emit('change', choose)
    },
    // 改变周
    changeAction(index) {
      console.log(index)
      for (let i = this.weekDate.length - 1; i >= 0; i--) {
        if (i === index) {
          this.weekDate[i].selected = true
          this.weekNum = index
        } else {
          this.weekDate[i].selected = false
        }
      }
      this.sendValue()
    },
    // 改变月份
    changeMonth(index) {
      console.log(index)
      for (let i = this.monthDate.length - 1; i >= 0; i--) {
        if (i === index) {
          this.monthDate[i].selected = true
          this.monthNum = index
        } else {
          this.monthDate[i].selected = false
        }
      }
      this.sendValue()
    },
    // 改变日期
    changeDateAction(index) {
      for (let i = this.dayDate.length - 1; i >= 0; i--) {
        if (i === index) {
          this.dayNum = index
          this.dayDate[i].selected = true
        } else {
          this.dayDate[i].selected = false
        }
      }
      this.sendValue()
    },
    // 改变按年日期
    changeYearDateAction(index) {
      for (let i = this.dayDateYear.length - 1; i >= 0; i--) {
        if (i === index) {
          this.yearDayNum = index
          this.dayDateYear[i].selected = true
        } else {
          this.dayDateYear[i].selected = false
        }
      }
      this.sendValue()
    }
  },
  mounted() {
  },
  created() {
    console.log('this.timeShow', this.timeShow)
    if (this.dateType === 1) {
      this.dayOne = this.timeShow.dayOne
    } else if (this.dateType === 2) {
      this.weekNum = this.timeShow.weekNum
      for (let i = this.weekDate.length - 1; i >= 0; i--) {
        if (i === this.weekNum) {
          this.weekDate[i].selected = true
        } else {
          this.weekDate[i].selected = false
        }
      }
    } else if (this.dateType === 3) {
      this.dayNum = this.timeShow.dayNum
      for (let i = this.dayDate.length - 1; i >= 0; i--) {
        if (i === this.dayNum) {
          this.dayDate[i].selected = true
        } else {
          this.dayDate[i].selected = false
        }
      }
    } else if (this.dateType === 4) {
      this.monthNum = this.timeShow.monthNum
      for (let i = this.monthDate.length - 1; i >= 0; i--) {
        if (i === this.monthNum) {
          this.monthDate[i].selected = true
        } else {
          this.monthDate[i].selected = false
        }
      }
      this.yearDayNum = this.timeShow.yearDayNum
      for (let i = this.dayDateYear.length - 1; i >= 0; i--) {
        if (i === this.yearDayNum) {
          this.dayDateYear[i].selected = true
        } else {
          this.dayDateYear[i].selected = false
        }
      }
    }
  }
}
</script>

<style scoped>
.date-week {
  width: 35px;
  height: 20px;
  border: 1px solid #dedede;
  padding: 0px;
  margin-left: 2px;
  margin-bottom: 4px;
  font-size: 12px;
}
.week-select {
  display: flex;
  justify-content: left;
  direction: row;
  margin-left: 100px;
  flex-wrap: wrap;
}
.week-select .active {
  background: #409EFF;
  color: #fff;
}
.day-input .el-input__inner {
  width: 40px;
  height: 25px;
}
.day-input {
  width: 40px !important;
  height: 30px;
  line-height: 30px;
  padding: 0px;
}
</style>
